import { Routes, Route } from "react-router-dom"
import { authRoutes} from "@/pages/auth/routes"
import NotFound from "@/pages/not-found"
import { appRoutes } from "@/pages/app/routes"
import HomePage from "@/pages/page"

function App() {
  return (
    <Routes>
      {authRoutes}
      {appRoutes}
      <Route path="" element={<HomePage />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}

export default App
